import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* rearrangeTherapistTask(action: any): SagaReturnType<any> {
    try {
        const response = yield call(therapistSchedulingServices.rearrangeTherapistTask, action.payload);
        if (response?.status === 200) {
            yield put({ type: TherapistAction.THERAPIST_REARRANGE_TASK_SUCCESS, payload: response.data });
        } else {
            throw response.data;
        }
    } catch (error) {
        yield put({ type: TherapistAction.THERAPIST_REARRANGE_TASK_FAILURE, payload: error });
    }
}

function* rearrangeTherapistTaskSaga() {
    yield takeEvery(TherapistAction.THERAPIST_REARRANGE_TASK_REQUEST, rearrangeTherapistTask);
}

export default rearrangeTherapistTaskSaga;
